import AbstractSystem from "../all/AbstractSystem";

class ZeasnSystem extends AbstractSystem {
    
    exit() {
        window.open('/node/homeuser', '_self', '');
        window.close();
    }
}

export default ZeasnSystem;



// WEBPACK FOOTER //
// ./src/devices/zeasn/System.js